import React, { useEffect } from 'react'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import Link from '@material-ui/core/Link'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { AiOutlineArrowLeft } from 'react-icons/ai'
import IconButton from '@material-ui/core/IconButton'
import Article from '../components/Article'
import PortfolioFrame from '../components/PortfolioFrame'

const HeaderOfListArticle = () => {
	return (
		<span style={{margin: "20px 0px"}}>
			<Grid item container justifyContent="center" xs={12} style={{color: "#fff"}}>
	            <Typography variant="h4" align="center">Blog</Typography>
	        </Grid>
	        <Grid item container justifyContent="center">
	            <Link component={RouterLink} to="/blog" color="inherit" style={{color: "#fff"}}>
	                <IconButton 
	                    className="icon-button" 
	                    title="Proyectos" 
	                    color="inherit"
	                    style={{ 
	                    	background: "#d3d3d320",
	                    	color: "#fff",
	                    	fontSize: '14px'
	            	 	}}
	                    >
	                    <AiOutlineArrowLeft />
	                </IconButton>
	                {' '}Volver
	            </Link>
	        </Grid>
        </span>
	)
}

const ArticlePage = ({ data }) => {
	const location = useLocation()

	useEffect(() => { 
		window.scroll(0,0)

		if (!/scroll/.test(location.search)) {
			return
		}

		const scrollQuery = location.search.match(/\?scroll=[0-9]+/)
		const scrollY = scrollQuery[0].match(/[0-9]+/)

		scrollY && localStorage.setItem('scrollY', scrollY[0])
	}, [])

	useEffect(() => {
		const body = document.querySelector("body")

		body.classList.add("article-page")

		return () => body.classList.remove("article-page")
	}, [])

	return (
		<PortfolioFrame classes="article-background">
			<HeaderOfListArticle />
			<Article data={data} />
			<HeaderOfListArticle />
		</PortfolioFrame>
	)
}

export default ArticlePage